// extracted by css-extract-rspack-plugin
module.exports =  {"menuBtn":"Sidebar__menuBtn--de3rO"};